import { useToast } from "@shopify/app-bridge-react";
import { useCallback, useState } from "react";
import Api from "../../../helpers/api";
import { Button, InlineStack, Select } from "@shopify/polaris";

export default ({
    locations = [],
    loading = false,
    setLoading = () => {},
    productType = null,
}) => {
    const toast = useToast();
    const [location, setLocation] = useState('');
    const [internalLoading, setInternalLoading] = useState(false);

    const resetQuantityOnHand = useCallback(() => {
        if (!location) {
            toast.show("You need to select Location first");
            return;
        }
        if (!productType || !productType.value) {
            toast.show("You need to select Product Type first");
            return;
        }

        if (!confirm(`Are you sure you want to reset all ON HAND quantity at selected location for ${productType.label}?`)) {
            return;
        }

        setLoading(true);
        setInternalLoading(true);

        Api
            .resetQuantityOnHand(location, productType.value)
            .then(() => {
                toast.show("On Hand Quantity resetting has been started. It will take couple of minutes to finish.");
            })
            .catch(() => {
                toast.show("Server error. Try again");
            })
            .finally(() => {
                setLoading(false);
                setInternalLoading(false);
            })
    }, [location, productType]);

    return (
        <InlineStack align="start" blockAlign="end" gap="100">
            <Select
                placeholder="-- Select Location --"
                label="Location"
                disabled={internalLoading}
                value={location}
                onChange={(val) => setLocation(val.toString())}
                options={locations.map((loc) => ({
                    label: loc.name,
                    value: loc.id.toString(),
                }))}
                requiredIndicator
            />
            <Button
                variant="primary"
                tone="critical"
                onClick={resetQuantityOnHand}
                loading={internalLoading}
                disabled={loading && !internalLoading}
            >
                Reset On Hand
            </Button>
        </InlineStack>
    );
};
